if (!customElements.get('gift-card-motion')) {
  customElements.define('gift-card-motion', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.choice = null;
      this.pending = false;
      this.failed = false;
      this.button.hidden = false;
      this.video.muted = true;
      this.video.addEventListener('playing', () => {
        if (!this.shouldPlay()) {
          this.video.pause();
          return;
        }
        this.setAttribute('data-ready', '');
        this.updateButton();
      }, options);
      this.video.addEventListener('pause', () => this.updateButton(), options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.removeAttribute('data-ready');
        this.removeAttribute('data-playing');
        this.button.hidden = true;
      }, options);
      this.button.addEventListener('click', () => {
        this.choice = this.video.paused;
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        this.choice = null;
        if (this.motion.matches) this.removeAttribute('data-ready');
        this.sync();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.15);
        this.sync();
      }, { threshold: [0, 0.15] });
      this.observer.observe(this);
      this.updateButton();
    }

    shouldPlay() {
      return this.isConnected && !this.failed && this.visible && document.visibilityState === 'visible' &&
        (this.choice === null ? !this.motion.matches : this.choice);
    }

    sync() {
      if (!this.shouldPlay()) {
        this.video.pause();
        this.updateButton();
        return;
      }
      if (this.pending || !this.video.paused) return;
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.pending = true;
      this.video.play().catch(error => {
        if (error.name !== 'AbortError') this.choice = false;
      }).finally(() => {
        this.pending = false;
        if (!this.shouldPlay()) this.video.pause();
        this.updateButton();
        if (this.shouldPlay() && this.video.paused) this.sync();
      });
    }

    updateButton() {
      const playing = !this.video.paused;
      this.toggleAttribute('data-playing', playing);
      this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
    }
  });
}
